// Resolver behind the `{~LinkTarget:Record~}` macro used by the Link InputType templates.
// Kept as a plain module (not a pict-template class) so the whitelist logic is unit-testable
// without standing up the bundle.

const _VALID_LINK_TARGETS = [ '_blank', '_self', '_parent', '_top' ];

/**
 * Resolve a descriptor's PictForm.LinkTarget into anchor attributes.
 *
 * The return value is spliced into raw markup, so the author's string is never echoed through --
 * only whitelisted targets are emitted. Absent or out-of-domain values yield '' (no attribute),
 * preserving the same-tab default rather than rendering target="".
 *
 * @param {any} pDescriptor - The form descriptor (the `Record` the macro resolves).
 * @return {string} The attribute fragment, or '' when no target applies.
 */
const resolveLinkTargetAttributes = (pDescriptor) =>
{
	const tmpTarget = pDescriptor?.PictForm?.LinkTarget;
	if (typeof tmpTarget !== 'string')
	{
		return '';
	}
	const tmpNormalizedTarget = tmpTarget.trim().toLowerCase();
	if (_VALID_LINK_TARGETS.indexOf(tmpNormalizedTarget) < 0)
	{
		return '';
	}
	// A new browsing context needs the rel guard against reverse tabnabbing.
	return (tmpNormalizedTarget === '_blank') ? 'target="_blank" rel="noopener noreferrer"' : `target="${tmpNormalizedTarget}"`;
};

module.exports = { resolveLinkTargetAttributes: resolveLinkTargetAttributes, VALID_LINK_TARGETS: _VALID_LINK_TARGETS };
